import React, { useContext } from 'react';
import {
  PAYPAL_BUTTON_TEXT,
  PAYPAL_BUTTON_IMG_TEXT,
} from '../../../brands/default/content/components/checkout';
import { PAYPAL_BUTTON_IMG } from '../../../config/constants/images';
import ThemeContext from '../../../providers/ThemeProvider';

const PaypalButton = () => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <img
        alt={PAYPAL_BUTTON_IMG_TEXT}
        className="paypal"
        src={PAYPAL_BUTTON_IMG}
      />
      <span className="sr-only">{PAYPAL_BUTTON_TEXT}</span>
      <style jsx>{`
        .paypal {
          width: 60%;
        }
        @media (max-width: ${theme.breakpoints.xlDown}) {
          .paypal {
            width: 52%;
          }
        }
      `}</style>
    </>
  );
};

export default PaypalButton;
